import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-jquiprogress-bar',
	templateUrl:'./JQUIProgressBarPage.html',
	styles: [],
	styleUrls:['./JQUIProgressBarPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class JQUIProgressBarPage
{
	mdContent_207 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.progressbar.JQUIProgressBar;
\`\`\``;
	mdContent_208 = `\`\`\`java
new JQUIProgressBar&lt;&gt;()
\`\`\``;
	mdContent_209 = `\`\`\`java
var bar = new JQUIProgressBar<>();
bar.getOptions().setValue(75);
\`\`\``;
}
